export const EXECUTE_NOW_REFRESH_ATTEMPTS = 5
export const EXECUTE_NOW_REFRESH_INTERVAL_MS = 1_000

type ExecuteNowRefreshStepState = {
  status?: string | null
  result_recorded_at?: string | null
}

const executeNowRefreshPendingStatuses = new Set([
  "READY",
  "RETRY_SCHEDULED",
  "ERROR",
  "EXECUTING",
  "DISPATCHED",
])

const normalizeStatus = (status?: string | null) => (status || "").toUpperCase()

export const isExecuteNowRefreshPending = (step?: ExecuteNowRefreshStepState | null) => {
  if (!step || step.result_recorded_at) return false

  return executeNowRefreshPendingStatuses.has(normalizeStatus(step.status))
}
